import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DateFormats } from '@nk/utils-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NkDatatableAbstractColumnComponent } from '../../datatable.utils';

@Component({
  selector: 'nk-date-column',
  templateUrl: './date-column.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DateColumnComponent<T> extends NkDatatableAbstractColumnComponent<T> {
  public date$: Observable<Date | string | null> = this.value$.pipe(
    map((value) => {
      if (value && value.row && value.prop) {
        const item = value.row && value.row[value.prop];
        if (item instanceof Date || typeof item === 'string') {
          return item;
        }
      }
      return null;
    }),
  );
  public dateFormats = DateFormats;
}
